// @ts-strict-ignore

import { mapActions, mapGetters } from 'vuex'

import { APP_CONSTS } from '../store/app/app.consts'

export const SteppedAnimationMixin = {
  computed: {
    ...mapGetters(APP_CONSTS.moduleName, {
      playedAnimations: APP_CONSTS.getters.playedAnimations,
    }),
    alreadyPlayedAnimation(): boolean {
      return this.playAnimationOnce && this.playedAnimations.includes(this.animationId)
    },
  },
  data() {
    return {
      animationId: undefined,
      playAnimationOnStart: true,
      playAnimationOnce: false,
      currentAnimationStep: undefined,
      animationStepDurationsInMillis: [1000, 1000, 1000],
      animationStepTimeout: undefined,
    }
  },
  methods: {
    ...mapActions(APP_CONSTS.moduleName, {
      addPlayedAnimation: APP_CONSTS.actions.addPlayedAnimation,
    }),
    onAnimationFinished(): void {},
  },
  created(): void {
    if (!this.animationId) {
      this.animationId = this.$options.name
    }
  },
  mounted(): void {
    if (this.playAnimationOnStart) {
      this.currentAnimationStep = 0
    }
    if (this.alreadyPlayedAnimation) {
      this.currentAnimationStep = this.animationStepDurationsInMillis.length - 1
    }
  },
  watch: {
    currentAnimationStep(): void {
      if (!this.alreadyPlayedAnimation) {
        clearTimeout(this.animationStepTimeout)
        const animationDurationInMillis: number =
          this.animationStepDurationsInMillis[this.currentAnimationStep]
        this.animationStepTimeout = setTimeout(() => {
          if (this.currentAnimationStep < this.animationStepDurationsInMillis.length - 1) {
            this.currentAnimationStep++
          } else {
            this.addPlayedAnimation(this.animationId)
            this.onAnimationFinished()
          }
        }, animationDurationInMillis)
      }
    },
  },
}
